import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ allowedRoles }) => {
  // Grab state definitions globally from your newly declared context architecture
  const { user, loading } = useAuth();

  // 1. Wait for the PHP backend to answer before evaluating anything
  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', fontFamily: 'sans-serif' }}>
        Verifying authorization...
      </div>
    );
  }

  // 2. If backend explicitly returned null or an empty session, bounce them
  if (user === null) {
    return <Navigate to="/admin" replace />;
  }

  // 3. Check role privileges
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/admin?error=Insufficient+Privileges" replace />;
  }

  // 4. Verification clean: render child paths
  return <Outlet />;
};

export default ProtectedRoute;